@use '../../scss/global' as *;
@use '../../scss/components/form-element.mixins' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-date-range {

    // ==== Shared Form Element Styles

    @include form-group();

    .invalid-date {
      margin: 0 0 1em 0.8em;
      padding: 0;
      font-size: 13px;
    }
  }
}
